export default __webpack_public_path__ + "media/images/logos/portfolio-3d76b27cedc7899139be0bb92002b93f.svg";